import React, { useCallback, useContext, useRef } from 'react';
import {
  SurveyContext,
  RegisterSurveyItemContainerRefContext,
  TriggerScrollToSurveyItemContext,
} from './Contexts';

export type SurveyItemRefsProviderOwnProps = {};

export type SurveyItemRefsProviderProps = SurveyItemRefsProviderOwnProps;

type SurveyItemRefDict = Record<string, HTMLDivElement>;

const SurveyItemRefsProvider: React.FC<SurveyItemRefsProviderProps> = props => {
  const refDict = useRef<SurveyItemRefDict>({});
  const survey = useContext(SurveyContext);

  const registerSurveyItemContainerRef = useCallback(
    (linkId: string, ref: HTMLDivElement | null) => {
      if (!linkId) return;

      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      refDict.current[linkId] = ref;
    },
    [],
  );

  const triggerScrollToSurveyItem = useCallback(
    (linkId: string) => {
      // target link ID may be nested for group items.  Scroll to the container in the path
      const possibleScrollLinks = survey.getPathToItem(linkId);

      const targetLinkId = possibleScrollLinks.find(_ => refDict.current[_]);
      if (!targetLinkId) {
        console.warn(
          `Unable to scroll to the item with link: "${targetLinkId}"`,
        );
        return;
      }

      const targetRef = refDict.current[targetLinkId];
      setTimeout(
        () =>
          targetRef?.scrollIntoView?.({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          }),
        300,
      );
    },
    [refDict, survey],
  );

  return (
    <RegisterSurveyItemContainerRefContext.Provider
      value={registerSurveyItemContainerRef}
    >
      <TriggerScrollToSurveyItemContext.Provider
        value={triggerScrollToSurveyItem}
      >
        {props.children}
      </TriggerScrollToSurveyItemContext.Provider>
    </RegisterSurveyItemContainerRefContext.Provider>
  );
};

export default SurveyItemRefsProvider;
